import { ErrorRounded } from "@material-ui/icons";
import React, { useState } from "react";
import styled from "styled-components";
import { Tooltip } from "./Tooltip";
// import ErrorIcon from '@mui/icons-material/Error';



const Styles = styled.div`
  --trans-1: all 0.15s ease-in-out;
  --fs-textfield: 16px;
  --fs-small: 12px;
  --border-radius: 8px;
  --border-2: #E5E5E5;
  --border-3: #CBCBCB;
  /* --secondry-1: var(--secondry-1); */
  --n-grey-2: var(--gray-15);
  --n-grey-5: var(--gray-4);

  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  &.color-white {
    align-items: normal;
    .text-field{
      color: #fff;
    }
  }
  .text-field {
    z-index: 3;
    width: calc(100% - 3rem);
    padding: calc(var(--fs-textfield) * 2.3) calc(1.5rem - 1px) calc(var(--fs-textfield) * 0.7);
    border-radius: var(--border-radius);
    border: 1px var(--border-2) solid;
    outline: none;
    transition: var(--trans-1) ;
    font-size: var(--fs-textfield);
    background: transparent;
    
    &.error-text {
      border: 1px var(--secondry-1) solid;
    }
    &.ltr-text {
      text-align: left;
      direction: ltr;
    }
    &.center-text {
      text-align: center;
      direction: ltr;
    }
    &.disabled {
      background-color: var(--n-grey-2);
      color: var(--n-grey-5);
    }
    :focus {
      border: 1px var(--border-3) solid;
    }
  }
  .eye {
    cursor: pointer;
    position: absolute;
    z-index: 5;
    top: calc(var(--fs-textfield) * 1.5);
    left: calc(var(--fs-textfield) * 1.5);
  }
  .label-textinput{
    z-index: 2;
    position: absolute;
    top: calc(var(--fs-textfield) * 1.5);
    right: calc(var(--fs-textfield) * 1.5);
    transition: var(--trans-1);
    &.disabled {
      color: var(--n-grey-5);
    }
  }
  .text-field:focus + .label-textinput {
    z-index: 5;
    top: calc(var(--fs-textfield) * 0.5);
    font-size: calc(var(--fs-textfield) * 0.8);
  }
  .text-field:not([value=""]) + .label-textinput {
    z-index: 5;
    top: calc(var(--fs-textfield) * 0.5);
    font-size: calc(var(--fs-textfield) * 0.8);
  }
  .help-input{
    z-index: 5;
    position: absolute;
    top: calc(var(--fs-textfield) * 1.35);
    left: calc(var(--fs-textfield) * 1.5);
    transition: var(--trans-1);
    .icon {
      width: 24px;
      transition: var(--trans-1);
    }
    &.password {
      left: calc(var(--fs-textfield) * 3.5);
    }
    .helpText{
      z-index: 5;
    }
  }
  .help-pass {
    padding: 0.3rem 0.3rem 0;
    font-size: var(--fs-small);
  }
  .error {
    display: flex;
    height: 0.75rem;
    font-size: var(--fs-small);
    text-align: start;
    width: 100%;
    .icon {
      width: 1rem;
      height: 1rem;
    }
    .text {
      margin: 0.1rem 0.2rem 0 0;
      color: red;
    }
  }
  @media screen and (max-width: 1445px) {
    .text-field {
      width: calc(100% - 2rem);
      padding: calc(var(--fs-textfield) * 1.6) calc(1rem - 1px) calc(var(--fs-textfield) * 0.5);
    }
    .eye {
      top: calc(var(--fs-textfield) * 1.05);
      left: calc(var(--fs-textfield) * 1.05);
    }
    .label-textinput{
      top: calc(var(--fs-textfield) * 1.05);
      right: calc(var(--fs-textfield) * 1.05);
    }
    .text-field:focus + .label-textinput {
      top: calc(var(--fs-textfield) * 0.3);
      font-size: calc(var(--fs-textfield) * 0.8);
    }
    .text-field:not([value=""]) + .label-textinput {
      top: calc(var(--fs-textfield) * 0.3);
      font-size: calc(var(--fs-textfield) * 0.8);
    }
    .help-input{
      top: calc(var(--fs-textfield) * 0.95);
      left: calc(var(--fs-textfield) * 1.05);
    }
  }
  @media screen and (max-width: 850px) {
   
    .text-field {
      width: calc(100% - 1.8rem);
    }
    &.mo-input{
      .text-field {
        width: calc(100% - 3rem);
      }
    }
  }
`;

// dokme chesm baray ramz ha
export const TextInputWTitle = ({
  style,
  name,
  type = "text",
  error,
  value,
  onchange,
  title,
  required,
  ltr,
  center,
  onEnter,
  help,
  disabled,
  inputmode,
  keys,
  classname,
  readonly
}) => {
  const [showPass, setShowPass] = useState(false);

  let errorComp = "";
  let classes = "text-field";
  if (error.toString()) {
    classes = "text-field error-text";
    errorComp = (
      <React.Fragment>
        <ErrorRounded style={{fontSize: "20px"}}/>
        <div className="text">{error}</div>
      </React.Fragment>
    );
  }

  if (ltr) {
    classes += " ltr-text";
  }

  if (center) {
    classes += " center-text";
  }
  if (disabled) {
    classes += " disabled";
  }
  //
  function handleKeyPress(e) {
    if (e.key === "Enter") {
      if (typeof onEnter === "function") {
        onEnter();
      }
    }
  }
  let helpElement = '';
  let helpElementPass = '';
  if((help) && !(type === "password")){
    helpElement = (
      <Tooltip ClassTooltip={"help-input"} ClassText={'helpText'} width="15rem" right={'-7.5rem'}>
        {help}
      </Tooltip>
    );
  } else if(help) {
    helpElementPass = (
      <div className="help-pass">
        {help}
      </div>
    )
  }

  return (
    <Styles style={style} key={keys} className={classname}>
      <input
        onKeyPress={handleKeyPress}
        className={classes} 
        name={name}
        type={showPass ? "text" : type}
        value={value}
        onChange={onchange}
        required={required}
        disabled={disabled}
        inputMode={inputmode}
        readOnly={readonly}
      />
      <label className={"label-textinput " + ((disabled) ? 'disabled' : '')}>
        {title}
      </label>
      {helpElement}
      {helpElementPass}
      <div className="error">{errorComp}</div>
    </Styles>
  );
};
